/* Trinity Fashions — tf-features.js v13
   FIXED: removed duplicate footer accordion handler
   (footer section has its own inline script — only one handler needed)
*/
'use strict';

function escHtml(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

/* ====================================================
   CART OPEN
===================================================== */
function tfOpenCartDrawer(){
  var cd=document.querySelector('cart-drawer');
  if(!cd){window.location.href='/cart';return;}
  if(typeof cd.open==='function'){try{cd.open();return;}catch(e){}}
  cd.classList.add('active','animate');
  document.body.classList.add('overflow-hidden');
}
window.tfOpenCartDrawer=tfOpenCartDrawer;

function tfCloseCartDrawer(){
  var cd=document.querySelector('cart-drawer');
  if(!cd)return;
  if(typeof cd.close==='function'){try{cd.close();return;}catch(e){}}
  cd.classList.remove('active','animate','is-active');
  document.body.classList.remove('overflow-hidden');
}
window.tfCloseCartDrawer=tfCloseCartDrawer;

function tfUpdateCartBadge(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var b=document.getElementById('tfh-cart-count');
    if(b){b.textContent=cart.item_count;b.style.display=cart.item_count>0?'flex':'none';}
    var tc=document.getElementById('tfc-count');
    if(tc)tc.textContent=cart.item_count;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function(el){el.textContent=cart.item_count;});
    /* Also update Dawn's cart-count-bubble if present */
    document.querySelectorAll('.cart-count-bubble').forEach(function(bubble){
      var num=bubble.querySelector('[aria-hidden="true"]');
      if(num)num.textContent=cart.item_count;
      bubble.style.display=cart.item_count>0?'':'none';
    });
  }).catch(function(){});
}
window.tfUpdateCartBadge=tfUpdateCartBadge;

document.addEventListener('submit',function(e){
  var form=e.target;
  if(!form||!form.action||!form.action.includes('/cart/add'))return;
  if(form.closest('product-form'))return;
  e.preventDefault();
  var fd=new FormData(form);
  var btn=form.querySelector('[type="submit"]');
  var orig=btn?btn.innerHTML:'';
  if(btn){btn.disabled=true;btn.textContent='Adding\u2026';}
  fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}})
    .then(function(r){return r.json();})
    .then(function(d){
      if(d.status&&d.status>=400){alert(d.description||'Could not add.');}
      else{
        tfUpdateCartBadge();
        if(window.publish&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate)
          window.publish(window.PUB_SUB_EVENTS.cartUpdate,{});
        setTimeout(tfOpenCartDrawer,200);
      }
      if(btn){btn.disabled=false;btn.innerHTML=orig;}
    }).catch(function(){if(btn){btn.disabled=false;btn.innerHTML=orig;}});
},true);

/* ====================================================
   WISHLIST
===================================================== */
var TFWishlist={
  KEY:'tf_wishlist',DATA_KEY:'tf_wishlist_data',
  get:function(){try{return JSON.parse(localStorage.getItem(this.KEY)||'[]');}catch(e){return[];}},
  getData:function(){try{return JSON.parse(localStorage.getItem(this.DATA_KEY)||'[]');}catch(e){return[];}},
  has:function(id){return this.get().includes(String(id));},
  add:function(id,pdata){
    var s=String(id),l=this.get();
    if(!l.includes(s)){l.push(s);localStorage.setItem(this.KEY,JSON.stringify(l));}
    if(pdata){var d=this.getData().filter(function(x){return x.id!==s;});d.push(Object.assign({},pdata,{id:s}));try{localStorage.setItem(this.DATA_KEY,JSON.stringify(d));}catch(e){}}
    this.sync();
  },
  remove:function(id){
    var s=String(id);
    localStorage.setItem(this.KEY,JSON.stringify(this.get().filter(function(i){return i!==s;})));
    try{localStorage.setItem(this.DATA_KEY,JSON.stringify(this.getData().filter(function(x){return x.id!==s;})));}catch(e){}
    this.sync();
  },
  toggle:function(id,pdata){this.has(id)?this.remove(id):this.add(id,pdata);},
  count:function(){return this.get().length;},
  findData:function(id){var s=String(id);return this.getData().find(function(d){return d.id===s;})||TFRecent.get().find(function(d){return String(d.id)===s;})||null;},
  sync:function(){
    var self=this;
    document.querySelectorAll('[data-wl-id]').forEach(function(btn){
      var id=btn.getAttribute('data-wl-id');
      if(!id)return;
      btn.classList.toggle('tf-wl-active',self.has(id));
      var icon=btn.querySelector('.tf-wl-icon');
      if(icon)icon.innerHTML=self.has(id)
        ?'<svg width="16" height="16" viewBox="0 0 24 24" fill="#C8102E" stroke="#C8102E" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        :'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      btn.style.pointerEvents='auto';
      btn.style.cursor='pointer';
      if(window.getComputedStyle(btn).position==='static'){
        btn.style.position='relative';
        btn.style.zIndex='5';
      }
      if(!btn._tfWlBound){
        btn._tfWlBound=true;
        btn.addEventListener('click',function(e){
          e.preventDefault();e.stopPropagation();
          var id2=this.getAttribute('data-wl-id');
          if(!id2)return;
          var card=this.closest('[data-product-id],.tf-prow-card,.tfcl-card,.tfs-card,.tfb-card');
          var pd=null;
          if(card){
            var nameEl=card.querySelector('.tf-prow-name,.tfcl-name,.tfs-name,.tfb-card-name,h3,h2');
            var priceEl=card.querySelector('.tf-prow-price,.tfcl-price,.tfs-price,.tfb-card-price');
            var imgEl=card.querySelector('img');
            var linkEl=card.querySelector('a[href]');
            pd={title:(nameEl&&nameEl.textContent||'').trim(),price:(priceEl&&priceEl.textContent||'').trim(),image:(imgEl&&imgEl.src)||'',url:(linkEl&&linkEl.getAttribute('href'))||'',vendor:''};
          }
          TFWishlist.toggle(id2,pd);
          window.dispatchEvent(new CustomEvent('tf:wishlist:updated'));
        },true);
      }
    });
    var badge=document.getElementById('tf-wl-badge');
    if(badge){var c=this.count();badge.textContent=c;badge.style.display=c>0?'flex':'none';}
    window.dispatchEvent(new CustomEvent('tf:wishlist:updated'));
  }
};
window.TFWishlist=TFWishlist;

window.tfWlAddToCart=function(e,handle){
  e.preventDefault();e.stopPropagation();
  var btn=e.currentTarget,origText=btn.textContent;
  btn.textContent='Adding\u2026';btn.disabled=true;
  fetch('/products/'+handle+'.js')
    .then(function(r){return r.json();})
    .then(function(prod){
      var vid=(prod.variants.find(function(v){return v.available;})||prod.variants[0]).id;
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:vid,quantity:1})});
    })
    .then(function(r){return r.json();})
    .then(function(data){
      if(data.id||data.items){
        btn.textContent='\u2713 Added!';btn.style.background='#2a7c45';
        tfUpdateCartBadge();
        if(window.publish&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate)window.publish(window.PUB_SUB_EVENTS.cartUpdate,{});
        setTimeout(tfOpenCartDrawer,200);
        setTimeout(function(){btn.textContent=origText;btn.style.background='';btn.disabled=false;},2500);
      }else{btn.textContent='Out of Stock';btn.disabled=false;}
    }).catch(function(){btn.textContent=origText;btn.disabled=false;});
};

function buildWlCard(p){
  var handle=p.url?(p.url.split('/products/').pop()||'').split('?')[0]:'';
  return '<div class="tf-pg-card-wrap"><a href="'+escHtml(p.url||'/')+'" class="tf-pg-card"><div class="tf-pg-img">'+(p.image?'<img src="'+escHtml(p.image)+'" alt="'+escHtml(p.title)+'" loading="lazy">':'<div class="tf-pg-img-placeholder"></div>')+'</div><div class="tf-pg-info">'+(p.vendor?'<div class="tf-pg-vendor">'+escHtml(p.vendor)+'</div>':'')+'<div class="tf-pg-name">'+escHtml(p.title)+'</div><div class="tf-pg-price">'+escHtml(p.price||'')+'</div>'+(handle?'<button class="tf-pg-atc" onclick="tfWlAddToCart(event,\''+handle+'\')" type="button">Move to Cart</button>':'')+'</div></a><button class="tf-pg-rm" onclick="TFWishlist.remove(\''+p.id+'\');renderWishlistPage();return false;" type="button" aria-label="Remove">&#x2715;</button></div>';
}
function renderWishlistPage(){
  var root=document.getElementById('tf-wl-root');if(!root)return;
  var ids=TFWishlist.get();
  if(!ids.length){root.innerHTML='<div class="tf-pg-empty"><svg class="tf-pg-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><div class="tf-pg-empty-title">Your wishlist is empty</div><div class="tf-pg-empty-sub">Tap \u2661 on any product to save it here.</div><a href="/collections/all" class="tf-pg-empty-btn">Explore Products \u2192</a></div>';return;}
  root.innerHTML='<div class="tf-pg-count">'+ids.length+' item'+(ids.length>1?'s':'')+' saved</div><div class="tf-pg-grid" id="tf-wl-grid-inner"></div>';
  var grid=document.getElementById('tf-wl-grid-inner');
  ids.forEach(function(id){
    var wrap=document.createElement('div');grid.appendChild(wrap);
    var cached=TFWishlist.findData(id);
    if(cached&&cached.title){wrap.outerHTML=buildWlCard(cached);return;}
    wrap.innerHTML='<div class="tf-pg-card-wrap"><div class="tf-pg-card"><div class="tf-pg-img tf-pg-img-loading"></div></div></div>';
    fetch('/search/suggest.json?q=id:'+id+'&resources[type]=product&resources[limit]=1')
      .then(function(r){return r.json();})
      .then(function(d){
        var prods=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        if(prods.length){var p=prods[0];var rawPrice=parseFloat(p.price||0);var pd={id:String(id),title:p.title||'',price:rawPrice>0?'\u20b9'+Math.round(rawPrice).toLocaleString('en-IN'):'',image:p.featured_image?p.featured_image.url:'',url:p.url||'/products/'+p.handle,vendor:p.vendor||''};TFWishlist.add(id,pd);wrap.outerHTML=buildWlCard(pd);}else wrap.style.display='none';
      }).catch(function(){wrap.style.display='none';});
  });
}
window.renderWishlistPage=renderWishlistPage;

var TFRecent={
  KEY:'tf_recently_viewed',MAX:16,
  track:function(item){if(!item||!item.id)return;var list=this.get().filter(function(p){return String(p.id)!==String(item.id);});list.unshift(Object.assign({},item,{id:String(item.id),ts:Date.now()}));try{localStorage.setItem(this.KEY,JSON.stringify(list.slice(0,this.MAX)));}catch(e){}},
  get:function(){try{return JSON.parse(localStorage.getItem(this.KEY)||'[]');}catch(e){return[];}}
};
window.TFRecent=TFRecent;

var TFPin = {
  KEY: 'tf_pincode',

  saved: function () {
    return localStorage.getItem(this.KEY) || '';
  },

  save: function (pin) {
    localStorage.setItem(this.KEY, pin);
  },

  getInfo: function (pin) {
    var self = this;

    // Validate pincode
    if (!/^\d{6}$/.test(pin)) {
      return Promise.resolve(null);
    }

    return fetch(
      'https://api.postalpincode.in/pincode/' + pin,
      {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache'
      }
    )
      .then(function (r) {

        if (!r.ok) {
          throw new Error('API request failed');
        }

        return r.json();
      })
      .then(function (d) {

        console.log('Pincode API Response:', d);

        if (
          d &&
          d[0] &&
          d[0].Status === 'Success' &&
          d[0].PostOffice &&
          d[0].PostOffice.length
        ) {

          var o = d[0].PostOffice[0];
          var days = self._days(o.State);

          return {
            pin: pin,
            city: o.Block || o.District || o.Name || 'Unknown',
            state: o.State || '',
            days: days,
            deliveryDate: self._date(days),
            valid: true
          };
        }

        // Pincode invalid
        return {
          pin: pin,
          valid: false,
          days: 7,
          deliveryDate: self._date(7)
        };
      })
      .catch(function (err) {

        console.error('Pincode API Error:', err);

        // Fallback response if API fails
        return {
          pin: pin,
          city: 'India',
          state: '',
          days: 5,
          deliveryDate: self._date(5),
          valid: true
        };
      });
  },

  _days: function (state) {

    if (
      [
        'Karnataka',
        'Tamil Nadu',
        'Andhra Pradesh',
        'Telangana',
        'Kerala'
      ].includes(state)
    ) {
      return 2;
    }

    if (
      [
        'Maharashtra',
        'Goa',
        'Gujarat',
        'Rajasthan'
      ].includes(state)
    ) {
      return 3;
    }

    if (
      [
        'Delhi',
        'Uttar Pradesh',
        'Haryana',
        'Punjab'
      ].includes(state)
    ) {
      return 4;
    }

    return 5;
  },

  _date: function (n) {

    var d = new Date();
    var added = 0;

    while (added < n) {
      d.setDate(d.getDate() + 1);

      // Skip Sunday
      if (d.getDay() !== 0) {
        added++;
      }
    }

    return d.toLocaleDateString(
      'en-IN',
      {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }
    );
  },

  syncAllWidgets: function (info) {

    document
      .querySelectorAll('[data-tf-pin-display]')
      .forEach(function (el) {
        el.textContent = info
          ? info.pin
          : 'Set location';
      });

    document
      .querySelectorAll('[data-tf-delivery-display]')
      .forEach(function (el) {

        if (info) {
          el.innerHTML =
            '<span class="tf-del-ok">' +
            '✓ Delivery by <strong>' +
            info.deliveryDate +
            '</strong> to <strong>' +
            info.city +
            '</strong>' +
            '</span>';
        }
      });
  }
};

window.TFPin = TFPin;

window.tfGpsDetect=function(resultEl,inputEl){if(!resultEl)return;if(!navigator.geolocation){resultEl.innerHTML='<span class="tf-pin-err">Location not supported</span>';return;}resultEl.innerHTML='<span class="tf-pin-loading">\uD83D\uDCCD Detecting\u2026</span>';navigator.geolocation.getCurrentPosition(function(pos){fetch('https://nominatim.openstreetmap.org/reverse?lat='+pos.coords.latitude+'&lon='+pos.coords.longitude+'&format=json',{headers:{'Accept-Language':'en','User-Agent':'TrinityFashions/1.0'}}).then(function(r){return r.json();}).then(function(d){var pin=(d.address&&d.address.postcode||'').replace(/\s/g,'');if(/^\d{6}$/.test(pin)){if(inputEl)inputEl.value=pin;window.tfPinCheck(pin,resultEl,null);}else resultEl.innerHTML='<span class="tf-pin-err">Could not detect pincode.</span>';}).catch(function(){resultEl.innerHTML='<span class="tf-pin-err">Detection failed.</span>';});},function(err){resultEl.innerHTML='<span class="tf-pin-err">'+(err.code===1?'Location denied.':'Detection failed.')+' Enter manually.</span>';},{timeout:12000});};window.tfPinCheck=function(pin,resultEl,savePin){if(!resultEl)return;if(!/^\d{6}$/.test(pin)){resultEl.innerHTML='<span class="tf-pin-err">Enter a valid 6-digit pincode</span>';return;}resultEl.innerHTML='<span class="tf-pin-loading">Checking\u2026</span>';TFPin.getInfo(pin).then(function(info){if(info&&info.valid){TFPin.save(pin);TFPin.syncAllWidgets(info);resultEl.innerHTML='<span class="tf-pin-ok">\u2713 Delivery to <strong>'+info.city+', '+info.state+'</strong> by <strong>'+info.deliveryDate+'</strong></span>';if(savePin)savePin(info);}else{resultEl.innerHTML='<span class="tf-pin-err">Pincode not found. Standard delivery: 5-7 days.</span>';}});}

document.addEventListener('DOMContentLoaded',function(){
  TFWishlist.sync();
  setTimeout(function(){TFWishlist.sync();},800);

  var pp=document.getElementById('tf-product-track-data');
  if(pp)TFRecent.track({id:pp.dataset.id,title:pp.dataset.title,price:pp.dataset.price,image:pp.dataset.image,url:pp.dataset.url});

  var saved=TFPin.saved();
  if(saved)TFPin.getInfo(saved).then(function(info){if(info)TFPin.syncAllWidgets(info);});

  if(document.getElementById('tf-wl-root'))renderWishlistPage();

  document.querySelectorAll('.tf-footer-acc-head').forEach(function(h){
    h.style.cursor='pointer';
  });

  var st=document.getElementById('tf-scroll-top');
  window.addEventListener('scroll',function(){if(st)st.classList.toggle('visible',window.scrollY>400);},{passive:true});

  tfUpdateCartBadge();

  /* Subscribe to Dawn pubsub cart update */
  function trySubscribe(attempts){
    if(window.subscribe&&window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate){
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,function(){
        tfUpdateCartBadge();
        setTimeout(tfOpenCartDrawer,150);
      });
    } else if((attempts||0)<15){
      setTimeout(function(){trySubscribe((attempts||0)+1);},300);
    }
  }
  trySubscribe();
});

/* ====================================================
   CART COUNT FIX v2 — fetch + XHR interceptor
   Catches ALL cart mutations from any source
===================================================== */
(function(){
  var _f=window.fetch;
  window.fetch=function(url,opts){
    var u=typeof url==='string'?url:(url&&url.url?url.url:'');
    var isMut=/\/cart\/(add|change|update|clear)(\.js)?/.test(u);
    return _f.apply(this,arguments).then(function(resp){
      if(isMut)setTimeout(tfUpdateCartBadge,200);
      return resp;
    });
  };
  var _xo=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,u){
    if(/\/cart\/(add|change|update)/.test(u))
      this.addEventListener('load',function(){setTimeout(tfUpdateCartBadge,200);});
    return _xo.apply(this,arguments);
  };
  /* Also listen to custom cart events from apps */
  document.addEventListener('cart:updated',function(e){
    if(e.detail&&typeof e.detail.item_count==='number'){
      var b=document.getElementById('tfh-cart-count');
      if(b){b.textContent=e.detail.item_count;b.style.display=e.detail.item_count>0?'flex':'none';}
    }
  });
})();
